/* Produktseite 2026 (Vorschau) — behaviour of the mbb-pd* sections. No library.

   Every section includes this file (each must work on its own in the theme
   editor); a guard on <html> lets it run once. Starts on DOMContentLoaded and
   again after the theme editor reloads a section (shopify:section:load).

   Buying area ([data-mbb-pd]):
     1 Gallery: stage that scrolls sideways, thumbnails, counter, caption, keyboard
     2 Lightbox
     3 Delivery date for an order placed now (status line and sticky bar)
     4 Wishlist (the shop's localStorage list, assets/mybearbrick-wishlist.js)
     5 Variants: price, reference price, status, quantity and button follow (A-620)
     6 Quantity stepper, limited to the stock
     7 Sticky bar whenever the button (or the notification form) is out of view
     8 (forms: sent the normal way, see sections/mbb-produkt.liquid)
     9 The explanation behind the i of „Unikat“
    10 Into the cart: the photo flies to the cart icon
   Other bands:
    11 Tabs ([data-mbb-pd-reiter]) and the links that open one
    12 Long description, shortened until asked
    13 Magnifier on the photo of the features in the authenticity band
    14 „Passt dazu“: our picks and Shopify's recommendations, with a switch
    15 Dimension line on the main photo (buying area)
    16 Colour names in the fact sheet on touch
    17 Pair card of the volume discount: the stamp lands once
    18 Free gift: follows the product into the cart

   The shipping calendar (cut-off, holidays, working days) is shared with the home
   page: assets/mbb-versandkalender.js (A-616). */
(() => {
  const html = document.documentElement;
  if (html.hasAttribute('data-mbb-pd-js')) return;
  html.setAttribute('data-mbb-pd-js', '');

  const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');
  const weich = () => (ruhig.matches ? 'auto' : 'smooth');

  /* ── 3 · Delivery date (calendar: assets/mbb-versandkalender.js) ──── */
  // The shipping calendar lives in assets/mbb-versandkalender.js (A-616); its tag may
  // come after this script's, so wait for it when it is not there yet.
  const mitKalender = (fn) => {
    if (window.mbbVersandkalender) fn();
    else document.addEventListener('mbb:versandkalender', fn, { once: true });
  };

  function lieferung(root) {
    const zeile = root.querySelector('[data-lieferung]');
    if (!zeile) return;
    const leiste = root.querySelector('[data-leiste-wann]');
    const de = !zeile.hasAttribute('data-en');
    const [transitMin, transitMax] = (zeile.dataset.transit || '1,3').split(',').map(Number);
    const samstag = zeile.hasAttribute('data-samstag');
    const wt = de ? ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'] : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const monateEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const datum = (t) => {
      const d = new Date(t);
      return de ? `${d.getUTCDate()}.${d.getUTCMonth() + 1}.` : `${d.getUTCDate()} ${monateEn[d.getUTCMonth()]}`;
    };
    const tagMitWt = (t) => `${wt[new Date(t).getUTCDay()]} ${datum(t)}`;
    const setze = (el, inhalt) => {
      if (el && el.innerHTML !== inhalt) el.innerHTML = inhalt;
    };

    const tick = () => {
      if (document.hidden) return;
      const { TAG, berlinJetzt, versandtagFuer, schlussStunde, plusArbeitstage } = window.mbbVersandkalender;
      const jetzt = berlinJetzt();
      const versand = versandtagFuer(jetzt);
      if (versand === null) return;
      const inTagen = Math.round((versand - jetzt.tag) / TAG);
      const spanne = `${tagMitWt(plusArbeitstage(versand, transitMin, samstag))}–${tagMitWt(plusArbeitstage(versand, transitMax, samstag))}`;
      const rest = inTagen * 1440 + schlussStunde(versand) * 60 - jetzt.minute;
      const std = Math.floor(rest / 60);
      const min = rest % 60;
      const dauer = de ? (std > 0 ? `${std} Std. ${min} Min.` : `${min} Min.`) : std > 0 ? `${std} h ${min} min` : `${min} min`;
      let text;
      if (inTagen === 0) {
        text = de
          ? `Bei dir <strong>${spanne}</strong>, wenn du in <strong>${dauer}</strong> bestellst.`
          : `With you <strong>${spanne}</strong> if you order within <strong>${dauer}</strong>.`;
      } else if (inTagen === 1) {
        // The German date ends with a dot itself — a comma follows it, never a second dot.
        text = de ? `Bei dir <strong>${spanne}</strong>, Versand morgen` : `With you <strong>${spanne}</strong>, ships tomorrow`;
      } else {
        text = de
          ? `Bei dir <strong>${spanne}</strong>, Versand am ${tagMitWt(versand)}`
          : `With you <strong>${spanne}</strong>, ships on ${tagMitWt(versand)}`;
      }
      setze(zeile, text);
      if (leiste) setze(leiste, de ? ` · bei dir ${spanne}` : ` · with you ${spanne}`);
    };
    mitKalender(() => {
      tick();
      setInterval(tick, 20000);
      document.addEventListener('visibilitychange', tick);
    });
  }

  /* ── 1 · Gallery ───────────────────────────────────────────────────── */
  function galerie(root) {
    const bahn = root.querySelector('[data-bahn]');
    if (!bahn) return;
    const bilder = [...bahn.children];
    const daumen = [...root.querySelectorAll('[data-daumen]')];
    const zaehler = root.querySelector('[data-zaehler]');
    let aktuell = 0;

    const markiere = (i) => {
      aktuell = i;
      daumen.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
      if (zaehler) zaehler.textContent = String(i + 1);
    };
    const zeige = (i, sanft = true) => {
      i = Math.max(0, Math.min(bilder.length - 1, i));
      bahn.scrollTo({ left: bilder[i].offsetLeft - bilder[0].offsetLeft, behavior: sanft ? weich() : 'auto' });
      markiere(i);
    };
    let rahmen = 0;
    bahn.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(rahmen);
        rahmen = requestAnimationFrame(() => {
          const i = Math.round(bahn.scrollLeft / Math.max(1, bahn.clientWidth));
          if (i !== aktuell && bilder[i]) markiere(i);
        });
      },
      { passive: true }
    );
    daumen.forEach((d) => d.addEventListener('click', () => zeige(Number(d.dataset.daumen))));
    bahn.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') zeige(aktuell + 1);
      else if (e.key === 'ArrowLeft') zeige(aktuell - 1);
      else return;
      e.preventDefault();
    });

    /* ── 2 · Lightbox ── */
    const dialog = root.querySelector('[data-lupe-dialog]');
    const gross = dialog && dialog.querySelector('[data-lupe-bild]');
    if (!dialog || !gross || typeof dialog.showModal !== 'function') return;
    const knoepfe = [...bahn.querySelectorAll('[data-lupe]')];
    let offen = 0;
    const lade = (i) => {
      offen = (i + knoepfe.length) % knoepfe.length;
      const img = knoepfe[offen].querySelector('img');
      gross.src = knoepfe[offen].dataset.lupe;
      gross.alt = img ? img.alt : '';
    };
    const oeffne = (i) => {
      lade(i);
      dialog.showModal();
    };
    knoepfe.forEach((k, i) => k.addEventListener('click', () => oeffne(i)));
    const lupe = root.querySelector('[data-lupe-offen]');
    if (lupe) lupe.addEventListener('click', () => oeffne(aktuell));
    dialog.querySelector('[data-lupe-zu]').addEventListener('click', () => dialog.close());
    dialog.querySelectorAll('[data-lupe-schritt]').forEach((k) =>
      k.addEventListener('click', () => lade(offen + Number(k.dataset.lupeSchritt)))
    );
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') lade(offen + 1);
      if (e.key === 'ArrowLeft') lade(offen - 1);
    });
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => zeige(offen, false));
  }

  /* ── 4 · Wishlist ──────────────────────────────────────────────────── */
  function merkliste(root) {
    const knoepfe = [...root.querySelectorAll('[data-merken]')];
    if (!knoepfe.length) return;
    const liste = () => window.myBearBrickWishlist;
    const stand = () => {
      const l = liste();
      knoepfe.forEach((k) => {
        const an = !!(l && l.contains(k.dataset.merken));
        const text = an ? k.dataset.textAn : k.dataset.textAus;
        k.setAttribute('aria-pressed', String(an));
        if (k.hasAttribute('data-mit-text')) {
          const t = k.querySelector('[data-merken-text]');
          if (t) t.textContent = text;
        } else {
          k.setAttribute('aria-label', text);
        }
      });
    };
    knoepfe.forEach((k) =>
      k.addEventListener('click', () => {
        const l = liste();
        if (!l) return;
        if (l.contains(k.dataset.merken)) l.remove(k.dataset.merken);
        else l.add(k.dataset.merken);
        stand();
      })
    );
    document.addEventListener('wishlist:updated', stand);
    if (document.readyState === 'complete') stand();
    else window.addEventListener('load', stand);
  }

  /* ── 6 · Quantity ──────────────────────────────────────────────────── */
  function menge(root) {
    const box = root.querySelector('[data-menge]');
    const feld = box && box.querySelector('[data-menge-feld]');
    if (!feld) return;
    const grenze = () => {
      const max = Number(feld.max) || Infinity;
      const n = Math.max(1, Math.min(max, Math.round(Number(feld.value) || 1)));
      if (String(n) !== feld.value) feld.value = String(n);
    };
    box.querySelectorAll('[data-menge-schritt]').forEach((k) =>
      k.addEventListener('click', () => {
        feld.value = String((Number(feld.value) || 1) + Number(k.dataset.mengeSchritt));
        grenze();
      })
    );
    feld.addEventListener('change', grenze);
  }

  /* ── 5 · Variants ──────────────────────────────────────────────────── */
  function varianten(root) {
    const gruppe = root.querySelector('[data-varianten]');
    if (!gruppe) return;
    const id = root.querySelector('.mbb-pd__form [name="id"]');
    const knopf = root.querySelector('.mbb-pd__form [data-kaufen]');
    const beschriftung = knopf && knopf.querySelector('span');
    const betrag = root.querySelector('[data-betrag]');
    const preis = root.querySelector('[data-preis]');
    const bezug = root.querySelector('[data-bezug]');
    const wahl = root.querySelector('[data-varianten-wahl]');
    const haupt = root.querySelector('[data-status-haupt]');
    const mengeBox = root.querySelector('[data-menge]');
    const mengeFeld = root.querySelector('[data-menge-feld]');
    const leistePreis = root.querySelector('[data-leiste-preis]');
    const leisteKnopf = root.querySelector('[data-leiste-knopf]');

    const statusZeile = (frei, bestand) => {
      if (!haupt) return;
      const t = haupt.dataset;
      let punkt = 'lager';
      let text = `<strong>${t.tLager}</strong> ${t.tOrt}`;
      if (!frei) {
        punkt = 'aus';
        text = `<strong>${t.tAus}</strong>`;
      } else if (bestand === 1) {
        punkt = 'letztes';
        text = `<strong>${t.tLetztes}</strong> ${t.tLetztesRest}`;
      }
      haupt.classList.toggle('ist-letztes', punkt === 'letztes');
      haupt.innerHTML = `<span class="mbb-pd__punkt mbb-pd__punkt--${punkt}" aria-hidden="true"></span><span>${text}</span>`;
    };

    gruppe.querySelectorAll('[data-variante]').forEach((b) =>
      b.addEventListener('click', () => {
        gruppe.querySelectorAll('[data-variante]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        const frei = b.dataset.frei === '1';
        const bestand = b.dataset.bestand === '' ? null : Number(b.dataset.bestand);
        if (wahl) wahl.textContent = b.dataset.titel;
        if (id) {
          id.value = b.dataset.variante;
          id.disabled = !frei;
        }
        const knopfText = knopf ? (frei ? knopf.dataset.tKaufen : knopf.dataset.tAus) : '';
        if (knopf) knopf.disabled = !frei;
        if (beschriftung) beschriftung.textContent = knopfText;
        if (leisteKnopf && knopf) {
          leisteKnopf.disabled = !frei;
          leisteKnopf.textContent = knopfText;
        }
        if (betrag) betrag.textContent = b.dataset.preis;
        if (leistePreis) leistePreis.textContent = b.dataset.preis;
        if (preis) {
          let streich = preis.querySelector('[data-streich]');
          if (b.dataset.streich) {
            if (!streich) {
              streich = document.createElement('s');
              streich.className = 'mbb-pd__streich';
              streich.setAttribute('data-streich', '');
              preis.prepend(streich);
            }
            streich.textContent = b.dataset.streich;
          } else if (streich) {
            streich.remove();
          }
          // Discount pill after the amount, rounded down in Liquid (data-rabatt).
          let pille = preis.querySelector('[data-rabatt]');
          if (b.dataset.rabatt) {
            if (!pille) {
              pille = document.createElement('span');
              pille.className = 'mbb-pd__rabattpille';
              pille.setAttribute('data-rabatt', '');
              preis.append(pille);
            }
            pille.textContent = b.dataset.rabatt;
          } else if (pille) {
            pille.remove();
          }
        }
        const vorlage = gruppe.querySelector(`[data-bezug-fuer="${b.dataset.variante}"]`);
        if (bezug && vorlage) bezug.innerHTML = vorlage.innerHTML;
        statusZeile(frei, bestand);
        if (mengeBox && mengeFeld) {
          mengeBox.hidden = !frei || (bestand !== null && bestand <= 1);
          if (bestand !== null) mengeFeld.max = String(bestand);
          else mengeFeld.removeAttribute('max');
          mengeFeld.value = '1';
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', b.dataset.variante);
        history.replaceState(null, '', url);
      })
    );
  }

  /* ── 7 · Sticky bar ────────────────────────────────────────────────── */
  function leiste(root) {
    const bar = root.querySelector('[data-leiste]');
    if (!bar) return;
    const ziel = root.querySelector('[data-kaufzeile]') || root.querySelector('.mbb-pd__formkasten');
    if (!ziel) return;
    const knopf = bar.querySelector('button');
    const kaufen = root.querySelector('.mbb-pd__form [data-kaufen]');
    knopf.addEventListener('click', () => {
      if (bar.querySelector('[data-leiste-formular]')) {
        const feld = root.querySelector('[data-restock-mail]');
        ziel.scrollIntoView({ behavior: weich(), block: 'center' });
        if (feld) feld.focus({ preventScroll: true });
      } else if (kaufen) {
        kaufen.click();
      }
    });
    const setze = (an) => {
      bar.classList.toggle('ist-an', an);
      bar.setAttribute('aria-hidden', String(!an));
      bar.inert = !an;
      html.classList.toggle('mbb-pd-leiste-an', an);
    };
    // Only once the buy row has left the view at the TOP (operator 04.11.2026): while
    // it is still below the fold — phone, short laptop screen — the bar would just
    // cover the page the visitor is about to scroll through. The root reaches far
    // down, so „below the fold“ still counts as intersecting and the observer fires
    // exactly when the row passes the top edge — also on a jump straight past it
    // (anchor link, fast fling), which a test of the position inside a plain
    // in/out callback would miss.
    new IntersectionObserver(([e]) => setze(!e.isIntersecting), { rootMargin: '0px 0px 100000px 0px' }).observe(ziel);
  }

  /* ── 9 · Explanation behind the i ──────────────────────────────────── */
  function tipp(root) {
    root.querySelectorAll('[data-tipp-knopf]').forEach((k) => {
      const blase = k.parentElement.querySelector('[data-tipp]');
      if (!blase) return;
      const setze = (an) => {
        blase.hidden = !an;
        k.setAttribute('aria-expanded', String(an));
      };
      k.addEventListener('click', () => setze(blase.hidden));
      k.addEventListener('blur', () => setze(false));
      k.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') setze(false);
      });
    });
  }

  /* ── 10 · Into the cart: the photo flies to the cart icon ──────────── */
  function flug(root) {
    const form = root.querySelector('.mbb-pd__form form');
    if (!form || ruhig.matches) return;
    form.addEventListener('submit', () => {
      const ziel = document.querySelector('#cart-icon-bubble');
      const bahn = root.querySelector('[data-bahn]');
      if (!ziel || !bahn) return;
      const i = Math.round(bahn.scrollLeft / Math.max(1, bahn.clientWidth));
      const quelle = bahn.children[i] && bahn.children[i].querySelector('.mbb-pd__foto');
      if (!quelle) return;
      const a = quelle.getBoundingClientRect();
      // Header 2026 slides back in on add-to-cart; ask it where the icon will be.
      const b = window.mbbKopf?.korbZiel?.() || ziel.getBoundingClientRect();
      const knopf = root.querySelector('.mbb-pd__form [data-kaufen]').getBoundingClientRect();
      const sichtbar = a.bottom > 0 && a.top < window.innerHeight;
      const start = sichtbar ? a : { left: knopf.left + knopf.width / 2 - 40, top: knopf.top - 80, width: 80, height: 80 };
      const kopie = new Image();
      kopie.src = quelle.currentSrc || quelle.src;
      kopie.className = 'mbb-pd__flug';
      kopie.alt = '';
      Object.assign(kopie.style, { left: `${start.left}px`, top: `${start.top}px`, width: `${start.width}px`, height: `${start.height}px` });
      document.body.appendChild(kopie);
      const dx = b.left + b.width / 2 - (start.left + start.width / 2);
      const dy = b.top + b.height / 2 - (start.top + start.height / 2);
      const s = Math.max(0.06, 28 / start.width);
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          kopie.style.transform = `translate(${dx}px, ${dy}px) scale(${s})`;
          kopie.style.opacity = '0.2';
        })
      );
      setTimeout(() => kopie.remove(), 800);
    });
  }

  /* ── 11 · Tabs ─────────────────────────────────────────────────────── */
  // Below 1,024 px the same panels are an accordion (operator 04.11.2026): one head
  // per panel, one open at a time like the tabs, but a tap on the open head closes it.
  // Same breakpoint as the CSS — there all five tabs fit in one row.
  const akkordeon = window.matchMedia('(max-width: 1023px)');
  function reiter(root) {
    const alle = [...root.querySelectorAll('[role="tab"]')];
    if (!alle.length) return;
    const koepfe = [...root.querySelectorAll('[data-akk]')];
    const kopfZu = (name) => koepfe.find((k) => k.dataset.akk === name);
    // name = data-reiter of the panel to show, or null for „all closed“ (accordion only).
    const zeige = (name) => {
      alle.forEach((x) => {
        const an = x.dataset.reiter === name;
        x.setAttribute('aria-selected', String(an));
        x.tabIndex = an ? 0 : -1;
        const flaeche = document.getElementById(x.getAttribute('aria-controls'));
        if (flaeche) flaeche.hidden = !an;
        const k = kopfZu(x.dataset.reiter);
        if (k) k.setAttribute('aria-expanded', String(an));
      });
    };
    const oeffne = (r, fokus) => {
      zeige(r.dataset.reiter);
      if (fokus) r.focus();
      // Keep the chosen tab in view in the row (it can still scroll at the edge).
      if (!akkordeon.matches) r.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    // The head moves up when a longer panel above it closes — bring it back under the
    // top edge, so the opened text starts in view.
    const kopfInSicht = (k) => {
      if (k.getBoundingClientRect().top < 0) k.scrollIntoView({ block: 'start' });
    };
    koepfe.forEach((k) =>
      k.addEventListener('click', () => {
        const offen = k.getAttribute('aria-expanded') === 'true';
        zeige(offen ? null : k.dataset.akk);
        if (!offen) kopfInSicht(k);
      })
    );
    // Back on a wide screen with everything closed: the tabs always show one panel.
    akkordeon.addEventListener('change', () => {
      if (!akkordeon.matches && !alle.some((x) => x.getAttribute('aria-selected') === 'true')) oeffne(alle[0]);
    });
    alle.forEach((r, i) => {
      r.addEventListener('click', () => oeffne(r));
      r.addEventListener('keydown', (e) => {
        let n = -1;
        if (e.key === 'ArrowRight') n = (i + 1) % alle.length;
        else if (e.key === 'ArrowLeft') n = (i + alle.length - 1) % alle.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = alle.length - 1;
        if (n < 0) return;
        e.preventDefault();
        oeffne(alle[n], true);
      });
    });
    root.mbbOeffneReiter = (name) => {
      const r = alle.find((x) => x.dataset.reiter === name);
      if (!r) return false;
      oeffne(r);
      // In the accordion the link lands on the head of the panel, not on the section top.
      const k = kopfZu(name);
      if (akkordeon.matches && k) {
        k.scrollIntoView({ behavior: weich(), block: 'start' });
        return true;
      }
      return false;
    };
  }
  // Links elsewhere on the page („Versandinformationen“, „So geht die Rückgabe“).
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-reiter-oeffnen]');
    if (!link) return;
    const band = document.querySelector('[data-mbb-pd-reiter]');
    if (band && band.mbbOeffneReiter && band.mbbOeffneReiter(link.dataset.reiterOeffnen)) e.preventDefault();
  });

  /* ── 16 · Colour names on touch ─────────────────────────────────────
     Hover and keyboard focus show the name by CSS; a tap toggles it, a tap
     elsewhere closes it. One open at a time. */
  document.addEventListener('click', (e) => {
    const feld = e.target.closest('[data-farbe]');
    document.querySelectorAll('[data-farbe].ist-offen').forEach((f) => {
      if (f !== feld) f.classList.remove('ist-offen');
    });
    if (feld) feld.classList.toggle('ist-offen');
  });

  /* ── 17 · Pair card of the volume discount ─────────────────────────
     Once, on first scroll into view: the card rises, the empty place slides in, the
     stamp „−15 %“ lands. The waiting state is set here, so without the script the
     card stands there finished; with reduced motion nothing moves. */
  function paarkarte(root) {
    const karte = root.querySelector('[data-paarkarte]');
    if (!karte || ruhig.matches || !('IntersectionObserver' in window)) return;
    karte.dataset.paarkarte = 'wartet';
    const beobachter = new IntersectionObserver(
      (eintraege) => {
        if (!eintraege[0].isIntersecting) return;
        beobachter.disconnect();
        // Two frames so the waiting state is painted before the transition starts.
        requestAnimationFrame(() => requestAnimationFrame(() => (karte.dataset.paarkarte = 'los')));
      },
      { threshold: 0.6 }
    );
    beobachter.observe(karte);
  }

  /* ── 18 · Free gift ──────────────────────────────────────────────────
     A product with a gift (custom.free-product) puts the gift into the cart with it,
     as the live page did (replace-sale-badge.js, which only knows the old button):
     after one of this product's variants went into the cart (Dawn's cartUpdate from
     a product-form — also the sticky bar, which submits the same form), the gift
     follows, once, if it is not in the cart yet, and the drawer is drawn again.
     The accessories' forms are product-forms too; their variants are not this
     product's, so they do not bring the gift. */
  function geschenk(root) {
    const karte = root.querySelector('[data-geschenk]');
    // Dawn declares PUB_SUB_EVENTS with const (constants.js): a global name, but not a
    // property of window — hence typeof on the bare names.
    if (!karte || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    const geschenkId = Number(karte.dataset.geschenk);
    const eigene = new Set(String(karte.dataset.varianten || '').split(',').map(Number));
    if (!geschenkId) return;
    let laeuft = false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, async (e) => {
      if (laeuft || !e || e.source !== 'product-form' || !eigene.has(Number(e.productVariantId))) return;
      laeuft = true;
      try {
        const korb = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        if (korb.items.some((i) => i.variant_id === geschenkId)) return;
        const drawer = document.querySelector('cart-drawer');
        const body = { items: [{ id: geschenkId, quantity: 1 }] };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map((x) => x.id);
          body.sections_url = window.location.pathname;
        }
        const antwort = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        }).then((r) => r.json());
        if (antwort.status) return;
        if (drawer && antwort.sections) drawer.renderContents(antwort);
      } catch (err) {
        console.warn('[mbb-pd] Geschenk nicht in den Warenkorb gelegt', err);
      } finally {
        laeuft = false;
      }
    });
  }

  /* ── 12 · Long description ─────────────────────────────────────────── */
  function text(root) {
    const box = root.querySelector('[data-text]');
    if (!box) return;
    const innen = box.querySelector('[data-text-innen]');
    const knopf = box.querySelector('[data-text-knopf]');
    // Beside a floating photo the short view reaches down to the photo's bottom
    // edge, so the column next to it is filled; otherwise nine lines.
    const bild = box.parentElement.querySelector(':scope > .mbb-pd-reiter__bild');
    const kurz = bild && getComputedStyle(bild).float !== 'none' ? Math.max(216, Math.round(bild.getBoundingClientRect().height)) : 216;
    box.style.setProperty('--kurz', `${kurz}px`);
    // Only worth a button when the text is clearly longer than the short view.
    if (!innen || !knopf || innen.scrollHeight < kurz + 124) return;
    box.classList.add('ist-kurz');
    knopf.hidden = false;
    knopf.addEventListener('click', () => {
      const offen = box.classList.toggle('ist-kurz') === false;
      knopf.setAttribute('aria-expanded', String(offen));
      knopf.textContent = offen ? knopf.dataset.weniger : knopf.dataset.weiter;
      if (!offen) box.scrollIntoView({ block: 'nearest', behavior: weich() });
    });
  }
  // The panel is hidden while another tab is open — measure when it opens, too.
  function textSobaldSichtbar(root) {
    const box = root.querySelector('[data-text]');
    if (!box) return;
    const flaeche = box.closest('[role="tabpanel"]');
    if (!flaeche || !flaeche.hidden) {
      text(root);
      return;
    }
    const beobachter = new MutationObserver(() => {
      if (!flaeche.hidden) {
        beobachter.disconnect();
        text(root);
      }
    });
    beobachter.observe(flaeche, { attributes: true, attributeFilter: ['hidden'] });
  }

  /* ── 13 · Magnifier on the photo of the features ───────────────────
     Mouse (hover-capable, fine pointer): a round glass follows the pointer and shows
     the spot under it three times larger, from the 2000-px file (loaded on the first
     hover). Touch: a tap zooms the photo in at that point (2.5×), moving the finger
     moves the view, a second tap zooms out; only while zoomed does the photo keep
     the finger (touch-action), otherwise the page scrolls over it as usual. Only
     transform and background-position move; with reduced motion no easing. */
  function lupenfeld(feld) {
    if (feld.dataset.lupeBereit) return;
    feld.dataset.lupeBereit = '1';
    const glas = feld.querySelector('.mbb-pd-echtheit__lupenglas');
    const bild = feld.querySelector('img');
    if (!glas || !bild) return;
    const maus = window.matchMedia('(hover: hover) and (pointer: fine)');
    const FAKTOR = 3;
    const ZOOM = 2.5;
    let geladen = false;
    const lade = () => {
      if (geladen) return;
      geladen = true;
      glas.style.backgroundImage = `url("${feld.dataset.gross}")`;
    };
    const lage = (e) => {
      const r = feld.getBoundingClientRect();
      return { r, x: Math.min(r.width, Math.max(0, e.clientX - r.left)), y: Math.min(r.height, Math.max(0, e.clientY - r.top)) };
    };
    // Mouse: the glass.
    feld.addEventListener('pointerenter', (e) => {
      if (e.pointerType !== 'mouse' || !maus.matches) return;
      lade();
      feld.classList.add('lupe-an');
    });
    feld.addEventListener('pointerleave', (e) => {
      if (e.pointerType === 'mouse') feld.classList.remove('lupe-an');
    });
    feld.addEventListener('pointermove', (e) => {
      if (e.pointerType === 'mouse') {
        if (!feld.classList.contains('lupe-an')) return;
        const { r, x, y } = lage(e);
        const d = glas.offsetWidth / 2;
        glas.style.transform = `translate(${x - d}px, ${y - d}px)`;
        glas.style.backgroundSize = `${r.width * FAKTOR}px ${r.height * FAKTOR}px`;
        glas.style.backgroundPosition = `${-(x * FAKTOR - d)}px ${-(y * FAKTOR - d)}px`;
      } else if (feld.classList.contains('ist-gross')) {
        const { r, x, y } = lage(e);
        bild.style.transformOrigin = `${(x / r.width) * 100}% ${(y / r.height) * 100}%`;
      }
    });
    // Touch: tap to zoom at that point, tap again to zoom out.
    let start = null;
    feld.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse') return;
      start = { x: e.clientX, y: e.clientY };
    });
    feld.addEventListener('pointerup', (e) => {
      if (e.pointerType === 'mouse' || !start) return;
      const getippt = Math.abs(e.clientX - start.x) < 8 && Math.abs(e.clientY - start.y) < 8;
      start = null;
      if (!getippt) return;
      if (feld.classList.contains('ist-gross')) {
        feld.classList.remove('ist-gross');
        feld.style.touchAction = '';
        return;
      }
      const { r, x, y } = lage(e);
      bild.srcset = '';
      bild.src = feld.dataset.gross;
      bild.style.transformOrigin = `${(x / r.width) * 100}% ${(y / r.height) * 100}%`;
      bild.style.setProperty('--zoom', String(ZOOM));
      feld.classList.add('ist-gross');
      feld.style.touchAction = 'none';
    });
  }

  /* ── 14 · Passt dazu: one row, our picks filled up by Shopify ───────
     Our picks come with the page; Shopify's recommendations are loaded well before
     the band comes on screen. The row (operator 04.11.2026): available picks, then
     available recommendations, then sold-out picks, then sold-out recommendations —
     none twice, at most four. Without any card the whole band stays hidden. */
  function dazu(root) {
    const reihe = root.querySelector('[data-reihe]');
    const url = root.dataset.url;
    if (!reihe) return;
    const hoechstens = Number(root.dataset.hoechstens) || 4;
    const huelle = root.closest('.shopify-section') || root;
    const ordne = (vorschlaege) => {
      const eigene = [...reihe.children];
      const vorhanden = new Set(eigene.map((li) => li.dataset.handle));
      const neue = vorschlaege.filter((li) => {
        if (vorhanden.has(li.dataset.handle)) return false;
        vorhanden.add(li.dataset.handle);
        return true;
      });
      const frei = (li) => li.dataset.frei !== 'false';
      const reihenfolge = [
        ...eigene.filter(frei),
        ...neue.filter(frei),
        ...eigene.filter((li) => !frei(li)),
        ...neue.filter((li) => !frei(li)),
      ].slice(0, hoechstens);
      reihe.replaceChildren(...reihenfolge);
      if (!reihenfolge.length) huelle.hidden = true;
    };
    if (!url) {
      ordne([]);
      return;
    }
    const lade = () =>
      fetch(url)
        .then((r) => (r.ok ? r.text() : ''))
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          ordne([...doc.querySelectorAll('[data-vorschlaege] > li')].map((li) => document.importNode(li, true)));
        })
        .catch(() => ordne([]));
    if (!('IntersectionObserver' in window)) {
      lade();
      return;
    }
    const beobachter = new IntersectionObserver(
      (eintraege) => {
        if (!eintraege[0].isIntersecting) return;
        beobachter.disconnect();
        lade();
      },
      { rootMargin: '0px 0px 1600px 0px' }
    );
    beobachter.observe(root);
  }

  /* ── 15 · Dimension line on the main photo ─────────────────────────
     Liquid puts the heights the photo shows on the first slide (data-massband
     „28|7“, largest first; labels in data-massband-text). The main photos are cut
     out: the script finds the figures as connected silhouettes on a small copy
     (alpha channel), keeps those of at least 3 % of the largest one's area, and
     draws only when there are exactly as many as heights — a line beside the wrong
     figure is worse than none. Each figure gets its own line: the small figure of a
     set stands closer to the camera and looks a bit larger than its share, a common
     scale would be wrong at one of them. The ends are pronounced (operator,
     03.11.2026): arrowheads, a cross bar and a dashed extension to the head and to
     the feet, so it is clear what is measured. Drawn in an SVG over the photo, it
     moves with it when swiping; redrawn when the stage changes size. */
  function massband(root) {
    const bahn = root.querySelector('[data-bahn]');
    const li = bahn && bahn.firstElementChild;
    if (!li || !li.dataset.massband) return;
    const foto = li.querySelector('.mbb-pd__foto');
    if (!foto) return;
    const hoehen = li.dataset.massband.split('|');
    const texte = (li.dataset.massbandText || '').split('|');
    const NS = 'http://www.w3.org/2000/svg';
    const el = (name, attrs, eltern, vor) => {
      const e = document.createElementNS(NS, name);
      Object.entries(attrs).forEach(([k, v]) => e.setAttribute(k, v));
      if (eltern) eltern.insertBefore(e, vor || null);
      return e;
    };

    const vermessen = () =>
      new Promise((fertig) => {
        const klein = new Image();
        klein.crossOrigin = 'anonymous';
        klein.onerror = () => fertig(null);
        klein.onload = () => {
          try {
            const B = 220;
            const H = Math.max(1, Math.round((B * klein.naturalHeight) / klein.naturalWidth));
            const c = document.createElement('canvas');
            c.width = B;
            c.height = H;
            const g = c.getContext('2d', { willReadFrequently: true });
            g.drawImage(klein, 0, 0, B, H);
            const a = g.getImageData(0, 0, B, H).data;
            let durchsichtig = 0;
            for (let i = 3; i < a.length; i += 4) if (a[i] < 16) durchsichtig++;
            // Not cut out (photo on a background): nothing to measure.
            if (durchsichtig < 0.1 * B * H) return fertig(null);
            const marke = new Int32Array(B * H);
            const teile = [];
            for (let start = 0; start < B * H; start++) {
              if (marke[start] || a[start * 4 + 3] <= 128) continue;
              const nr = teile.length + 1;
              const t = { flaeche: 0, x0: B, x1: 0, y0: H, y1: 0, punkte: [] };
              const stapel = [start];
              marke[start] = nr;
              while (stapel.length) {
                const p = stapel.pop();
                const x = p % B;
                const y = (p - x) / B;
                t.flaeche++;
                t.punkte.push(p);
                if (x < t.x0) t.x0 = x;
                if (x > t.x1) t.x1 = x;
                if (y < t.y0) t.y0 = y;
                if (y > t.y1) t.y1 = y;
                for (const q of [p - 1, p + 1, p - B, p + B]) {
                  if (q < 0 || q >= B * H || marke[q]) continue;
                  if ((q === p - 1 && x === 0) || (q === p + 1 && x === B - 1)) continue;
                  if (a[q * 4 + 3] > 128) {
                    marke[q] = nr;
                    stapel.push(q);
                  }
                }
              }
              teile.push(t);
            }
            const groesste = Math.max(0, ...teile.map((t) => t.flaeche));
            const figuren = teile.filter((t) => t.flaeche >= 0.03 * groesste).sort((x, y) => y.flaeche - x.flaeche);
            if (figuren.length !== hoehen.length) return fertig(null);
            // Where the silhouette is at the head and at the feet (for the extension lines).
            const rand = (t, oben) => {
              const band = Math.max(2, Math.round(0.03 * (t.y1 - t.y0)));
              let l = B;
              let r = 0;
              t.punkte.forEach((p) => {
                const y = Math.floor(p / B);
                if (oben ? y > t.y0 + band : y < t.y1 - band) return;
                const x = p % B;
                if (x < l) l = x;
                if (x > r) r = x;
              });
              return { l: l / B, r: (r + 1) / B };
            };
            fertig(
              figuren.map((t) => ({
                x0: t.x0 / B,
                x1: (t.x1 + 1) / B,
                y0: t.y0 / H,
                y1: (t.y1 + 1) / H,
                oben: rand(t, true),
                unten: rand(t, false),
              }))
            );
          } catch (e) {
            fertig(null);
          }
        };
        const quelle = foto.currentSrc || foto.src;
        klein.src = /[?&]width=\d+/.test(quelle) ? quelle.replace(/([?&])width=\d+/, '$1width=440') : quelle + (quelle.includes('?') ? '&' : '?') + 'width=440';
      });

    let figuren = null;
    const zeichne = () => {
      const alt = li.querySelector('.mbb-pd__massband');
      if (alt) alt.remove();
      if (!figuren) return;
      const W = li.clientWidth;
      const H = li.clientHeight;
      const nw = foto.naturalWidth || 1;
      const nh = foto.naturalHeight || 1;
      const s = Math.min(W / nw, H / nh);
      const ox = (W - nw * s) / 2;
      const oy = (H - nh * s) / 2;
      const X = (f) => ox + f * nw * s;
      const Y = (f) => oy + f * nh * s;
      const svg = el('svg', { class: 'mbb-pd__massband', viewBox: `0 0 ${W} ${H}`, 'aria-hidden': 'true', focusable: 'false' }, li);
      // The large figure gets its line on the side away from the small one; a single
      // figure on the side with more room.
      const seiten = figuren.map(() => 'links');
      if (figuren.length === 2) {
        const kleinRechts = figuren[1].x0 + figuren[1].x1 > figuren[0].x0 + figuren[0].x1;
        seiten[0] = kleinRechts ? 'links' : 'rechts';
        seiten[1] = kleinRechts ? 'rechts' : 'links';
      } else if (figuren[0].x0 < 1 - figuren[0].x1) {
        seiten[0] = 'rechts';
      }
      const abstand = Math.max(10, W * 0.02);
      const tinte = '#1a1a1a';
      figuren.forEach((f, i) => {
        const links = seiten[i] === 'links';
        const x = links ? X(f.x0) - abstand : X(f.x1) + abstand;
        const y1 = Y(f.y0);
        const y2 = Y(f.y1);
        if (y2 - y1 < 40) return;
        const g = el('g', {}, svg);
        // Dashed extensions from the cross bars to the head and to the feet.
        [
          [y1, links ? X(f.oben.l) - 4 : X(f.oben.r) + 4],
          [y2, links ? X(f.unten.l) - 4 : X(f.unten.r) + 4],
        ].forEach(([y, bis]) => {
          if (links ? bis > x + 13 : bis < x - 13) {
            el('line', { x1: x, x2: bis, y1: y, y2: y, stroke: tinte, 'stroke-width': 1, 'stroke-dasharray': '3 3', opacity: 0.55 }, g);
          }
        });
        el('line', { x1: x - 11, x2: x + 11, y1, y2: y1, stroke: tinte, 'stroke-width': 2, 'stroke-linecap': 'round' }, g);
        el('line', { x1: x - 11, x2: x + 11, y1: y2, y2, stroke: tinte, 'stroke-width': 2, 'stroke-linecap': 'round' }, g);
        el('line', { x1: x, x2: x, y1: y1 + 8, y2: y2 - 8, stroke: tinte, 'stroke-width': 1.5 }, g);
        el('path', { d: `M${x} ${y1} l-4.5 9 h9 Z`, fill: tinte }, g);
        el('path', { d: `M${x} ${y2} l-4.5 -9 h9 Z`, fill: tinte }, g);
        // Label on the outer side: the large figure's at the middle, a small one's at
        // its upper end (its middle would meet the zoom button in the corner).
        const t = el('text', { x: 0, y: 0, 'dominant-baseline': 'central' }, g);
        t.textContent = texte[i] || `${hoehen[i]} cm`;
        const pw = t.getBBox().width + 16;
        const ph = 24;
        const ym = i === 0 ? (y1 + y2) / 2 : y1 + ph / 2 + 4;
        const px = links ? x - 12 - pw : x + 12;
        // No room for the label: no line at all rather than one without its number.
        if (px < 4 || px + pw > W - 4) {
          g.remove();
          return;
        }
        el('rect', { x: px, y: ym - ph / 2, width: pw, height: ph, rx: ph / 2, fill: '#fff', stroke: 'rgba(26,26,26,0.25)' }, g, t);
        t.setAttribute('x', String(px + 8));
        t.setAttribute('y', String(ym));
      });
    };

    const los = () =>
      vermessen().then((f) => {
        figuren = f;
        zeichne();
        // No line on the main photo: the mark saying what it shows takes the corner.
        const inhalt = li.querySelector('.mbb-pd__bildinhalt');
        if (inhalt && !li.querySelector('.mbb-pd__massband g')) inhalt.hidden = false;
        if (figuren && 'ResizeObserver' in window) {
          let breite = li.clientWidth;
          new ResizeObserver(() => {
            if (li.clientWidth === breite) return;
            breite = li.clientWidth;
            zeichne();
          }).observe(li);
        }
      });
    // After the photo, and when the browser is idle — never in the way of the first paint.
    const spaeter = () => ('requestIdleCallback' in window ? requestIdleCallback(los, { timeout: 2000 }) : setTimeout(los, 300));
    if (foto.complete && foto.naturalWidth) spaeter();
    else foto.addEventListener('load', spaeter, { once: true });
  }

  function start(root) {
    if (root.dataset.mbbPdBereit) return;
    root.dataset.mbbPdBereit = '1';
    if (root.hasAttribute('data-mbb-pd')) {
      galerie(root);
      massband(root);
      lieferung(root);
      merkliste(root);
      menge(root);
      varianten(root);
      leiste(root);
      tipp(root);
      flug(root);
      paarkarte(root);
      geschenk(root);
    } else if (root.hasAttribute('data-mbb-pd-reiter')) {
      reiter(root);
      textSobaldSichtbar(root);
    } else if (root.hasAttribute('data-mbb-pd-dazu')) {
      dazu(root);
    }
  }
  const alle = () => {
    document.querySelectorAll('[data-mbb-pd], [data-mbb-pd-reiter], [data-mbb-pd-dazu]').forEach(start);
    document.querySelectorAll('[data-lupenfeld]').forEach(lupenfeld);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', alle);
})();
